import { useMutation } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

export type UpdateColumnParams = {
  rowId: string;
  field: string;
  value:
    | string[]
    | string
    | number
    | null
    | { value: string | null; refUrn: string };
};

export const useUpdateColumn = () => {
  return useMutation({
    mutationFn: ({ rowId, field, value }: UpdateColumnParams) =>
      MediaPlan.updateColumn({
        urlParams: { mediaDataId: rowId },
        data: { [field]: value },
      }),
  });
};
